import { Actions } from '@ngrx/effects';
var AppEffects = /** @class */ (function () {
    function AppEffects(actions$) {
        this.actions$ = actions$;
    }
    return AppEffects;
}());
export { AppEffects };
